import { StateSchema } from 'app/config/storeConfig/types';
import { UserNoteDrawerSchema } from '../types';

export const getUserNoteDrawerState = (state: StateSchema): UserNoteDrawerSchema => state.userNoteDrawer;
